import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  getCurrentUserShift: 'techsavanna_pos.api.shift_api.get_current_user_shift',
};

export const fetchActiveShift = createAsyncThunk(
  'shift/fetchActiveShift',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(ENDPOINTS.getCurrentUserShift);
      const data = response.data?.message || response.data;
      return {
        shift: data?.shift || null,
        hasAssignment: Boolean(data?.has_assignment),
        onShift: Boolean(data?.on_shift),
      };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch active shift');
    }
  }
);

const shiftSlice = createSlice({
  name: 'shift',
  initialState: {
    activeShift: null,
    hasAssignment: false,
    onShift: false,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearActiveShift: (state) => {
      state.activeShift = null;
      state.hasAssignment = false;
      state.onShift = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActiveShift.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchActiveShift.fulfilled, (state, action) => {
        state.isLoading = false;
        state.activeShift = action.payload.shift;
        state.hasAssignment = action.payload.hasAssignment;
        state.onShift = action.payload.onShift;
      })
      .addCase(fetchActiveShift.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearActiveShift } = shiftSlice.actions;
export default shiftSlice.reducer;
